import store from '@/store';
import i18n from '@/plugins/i18n';


export default function cguAccept({ next, router }) {
  store.dispatch('auth/me').then(
    (res) => {
      if (!store.getters['auth/user'].cgu_accepted) {
        return router.replace({ name: 'dashboard', params: { locale: i18n.locale } });
      }
    }, err => router.replace({ name: 'login', params: { locale: i18n.locale } }),
  );
}
